import React from "react";
import { Pressable, View, ScrollView } from "react-native";
import AppActivityIndicator from "@/components/shared/AppActivityIndicator";
import AppHeader from "@/components/shared/AppHeader";
import { AppBackButton } from "@/components/shared/Buttons";
import { Ionicons } from "@expo/vector-icons";
import Container from "@/components/shared/AppContainer";
import {
  SaveStatusIndicator,
  SaveStatusProvider,
} from "@/components/settings/SaveStatus";
import { CONTENT_MAX_WIDTH } from "@/components/settings/theme";
import tw from "twrnc";
import { useNavigation, useRoute } from "@react-navigation/native";

// Frame of every settings screen (event settings, profile): header (back,
// save status) and one scrolling column of CONTENT_MAX_WIDTH. Auto-saving
// forms inside report to the SaveStatusProvider; the header shows the result.
const EventSettingsScreenContainer = ({
  backButtonLite,
  loading,
  children,
  useOwnScrollLayout = false,
  hideHeader = false,
  // Where Back goes when there's no screen to go back to (an opened link).
  fallbackRoute,
}) => {
  const navigation = useNavigation();
  const route = useRoute();

  const back = () => {
    const routeParams = route?.params;
    const fallbackSlug =
      routeParams?.slug ||
      routeParams?.event?.slug ||
      routeParams?.relatedEvent?.slug;

    if (navigation.canGoBack()) {
      navigation.goBack();
    } else if (fallbackRoute) {
      navigation.navigate(fallbackRoute);
    } else if (fallbackSlug) {
      navigation.navigate("EventEdit", {
        ...(routeParams || {}),
        slug: fallbackSlug,
      });
    } else {
      navigation.navigate("EventList");
    }
  };

  return (
    <SaveStatusProvider>
      <Container>
        {!hideHeader && (
          <AppHeader
            leftButtonComponent={
              backButtonLite ? (
                <Pressable onPress={back}>
                  <Ionicons
                    name="close-outline"
                    size={30}
                    style={tw`opacity-30`}
                    color="#787878"
                  />
                </Pressable>
              ) : (
                <AppBackButton onPress={back} />
              )
            }
            hasLeftButton={true}
            hasRightButton={true}
            renderRightButton={() => (
              <>
                <SaveStatusIndicator />
                {loading && <AppActivityIndicator />}
              </>
            )}
          />
        )}

        {useOwnScrollLayout ? (
          <View style={tw`flex-1 w-full self-center`}>
            <View style={tw`flex-1`}>{children}</View>
          </View>
        ) : (
          <ScrollView
            contentContainerStyle={[
              tw`w-full self-center px-5 pt-2 pb-12`,
              { maxWidth: CONTENT_MAX_WIDTH + 40 },
            ]}
            keyboardShouldPersistTaps="handled"
          >
            {children}
          </ScrollView>
        )}
      </Container>
    </SaveStatusProvider>
  );
};

export default EventSettingsScreenContainer;
